<template>
  <div class="project-time-tracking">
    <p v-if="isNewProject" class="text-muted">{{ $t('saveNewProjectFirst') }}</p>
    <TimeTrackingTable v-else :project="project" :isReadOnly="isBlockReadOnly" />
  </div>
</template>

<script>
import TimeTrackingTable from '@/components/TimeTrackingTable';
import { AccessBlockMixin } from '@/mixins/accessBlock';

/** Number of the unsaved project (ProjectEdit `_new`): the block needs a saved project. */
const NEW_PROJECT_NUMBER = '_new';

/**
 * Block project-time-tracking ("Zeiterfassung", see feature page projekt-montage): the time
 * trackings of the project. `TimeTrackingTable` loads, writes and exports through the paths of the
 * block (`projectNumber` in the time tracking actions) and makes itself read-only for viewers
 * (`isReadOnly`).
 *
 * No `BlockFieldset` root: a disabled fieldset would also disable the filters, the paging and the
 * export of the table, which viewers need; every write control is covered by `isReadOnly`.
 */
export default {
  name: 'ProjectTimeTracking',
  components: {
    TimeTrackingTable,
  },
  mixins: [AccessBlockMixin],
  props: {
    /** The page project; the block data (the entries) is loaded by `TimeTrackingTable`. */
    project: { type: Object, required: true },
  },
  computed: {
    isNewProject() {
      return this.project.number === NEW_PROJECT_NUMBER;
    },
  },
};
</script>
